import "./CardItemBlock.scss";
import {
  ArrowLineUpRightIcon,
  ArrowRightIcon,
  CalendarBlankIcon,
  InfoSmallIcon,
  Label,
} from "/App.Components";
import { createSpreadableBem } from "/Helpers/createBem";
import { CardItemBlockProps } from "/Models/Generated/CardItemBlockProps";
import { DesignTheme } from "/Models/Generated/DesignTheme";
import { ColorTheme } from "/Models/Models/ColorTheme";

interface CardItemBlockWithThemeProps extends CardItemBlockProps {
  theme?: DesignTheme;
}

const CardItemBlock = ({
  label,
  link,
  heading,
  deadline,
  openExternalLinkAriaLabel,
  theme,
}: CardItemBlockWithThemeProps) => {
  const bem = createSpreadableBem("card-item-block-norad");
  return (
    <a
      href={link?.href}
      target={link?.isExternal ? "_blank" : undefined}
      {...bem("", { "--insight": theme === DesignTheme.Insight })}
    >
      {theme !== DesignTheme.Insight && (
        <div {...bem("__label-and-link-container")}>
          {label && <Label outlined text={label} isExternal={false} />}

          {link?.isExternal ? (
            <ArrowLineUpRightIcon
              size="32"
              thickness="Light"
              color={ColorTheme.default}
              ariaLabel={openExternalLinkAriaLabel}
            />
          ) : (
            <ArrowRightIcon
              size="32"
              thickness="Light"
              color={ColorTheme.default}
            />
          )}
        </div>
      )}

      {heading && (
        <div
          {...bem("__heading-container", {
            "--insight": theme === DesignTheme.Insight,
          })}
        >
          <h3
            {...bem("__heading", {
              "--insight": theme === DesignTheme.Insight,
            })}
          >
            <span>{heading}</span>
          </h3>
          {theme === DesignTheme.Insight &&
            (link?.isExternal ? (
              <ArrowLineUpRightIcon
                size="32"
                thickness="Light"
                color={ColorTheme.default}
                ariaLabel={openExternalLinkAriaLabel}
              />
            ) : (
              <ArrowRightIcon
                size="32"
                thickness="Light"
                color={ColorTheme.default}
              />
            ))}
        </div>
      )}
      {deadline && (
        <InfoSmallIcon
          text={deadline}
          icon={CalendarBlankIcon}
          theme={theme === DesignTheme.Insight ? "insightBlue" : "standard"}
        />
      )}
    </a>
  );
};

export default CardItemBlock;
